/* Nakylo · liste d'avis en bandeau qui défile tout seul (réglage « Présentation » du bloc nky-avis-liste, 03/10/2026).
   On recopie les cartes (copies muettes pour les lecteurs d'écran, sans les attributs de l'éditeur) jusqu'à dépasser la
   largeur de l'écran, puis on double l'ensemble : l'animation CSS glisse de −50 % et boucle sans raccord.
   Arrêt au survol, au toucher et au clavier. Si le visiteur demande moins de mouvement : pas d'animation, on fait
   défiler au doigt. Les avis « Exemple » ne sont rendus que dans l'éditeur : chez les clients il n'y a rien à animer. */
(function () {
  function copier(carte) {
    var k = carte.cloneNode(true);
    k.setAttribute('aria-hidden', 'true');
    k.setAttribute('inert', '');
    [k].concat(Array.prototype.slice.call(k.querySelectorAll('*'))).forEach(function (e) {
      e.removeAttribute('id');
      Array.prototype.slice.call(e.attributes).forEach(function (a) { if (a.name.indexOf('data-shopify-editor') === 0) e.removeAttribute(a.name); });
    });
    return k;
  }
  function preparer(zone) {
    var piste = zone.querySelector('.nky-avis-liste');
    if (!piste || zone.dataset.nkyDefile) return;
    zone.dataset.nkyDefile = '1';
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cartes = Array.prototype.filter.call(piste.children, function (c) { return c.querySelector('.nky-avis'); });
    if (cartes.length < 2) return;
    var largeurVoulue = zone.clientWidth, garde = 0;
    while (piste.scrollWidth < largeurVoulue && garde++ < 6) cartes.forEach(function (c) { piste.appendChild(copier(c)); });
    Array.prototype.slice.call(piste.children).forEach(function (c) { if (c.querySelector('.nky-avis')) piste.appendChild(copier(c)); });
    zone.classList.add('is-anime');
  }
  /* même principe pour un groupe réglé « bandeau qui défile » (nky-groupe, 09/10) : toutes ses cases défilent */
  function preparerGroupe(zone) {
    var piste = zone.querySelector('.nky-b-groupe__piste');
    if (!piste || zone.dataset.nkyDefile) return;
    zone.dataset.nkyDefile = '1';
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cases = Array.prototype.slice.call(piste.children);
    if (cases.length < 2) return;
    var garde = 0;
    while (piste.scrollWidth < zone.clientWidth && garde++ < 6) cases.forEach(function (c) { piste.appendChild(copier(c)); });
    Array.prototype.slice.call(piste.children).forEach(function (c) { piste.appendChild(copier(c)); });
    zone.classList.add('is-anime');
  }
  function tout() {
    document.querySelectorAll('[data-nky-avis-defile]').forEach(preparer);
    document.querySelectorAll('[data-nky-groupe-defile]').forEach(preparerGroupe);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  document.addEventListener('shopify:section:load', function (e) {
    (e.target || document).querySelectorAll('[data-nky-avis-defile]').forEach(function (z) { delete z.dataset.nkyDefile; preparer(z); });
    (e.target || document).querySelectorAll('[data-nky-groupe-defile]').forEach(function (z) { delete z.dataset.nkyDefile; preparerGroupe(z); });
  });
})();
